const translatePropertyLabels = (label: string) => {
  let newLabel = label;
  newLabel = newLabel.replace(/\[(\d+)]./, (_, num) => ` ${Number(num) + 1} `);
  newLabel = newLabel.replace(/\[(\d+)]./, (_, num) => ` ${Number(num) + 1} `);
  newLabel = newLabel.replace(/\[(\d+)]./, (_, num) => ` ${Number(num) + 1} `);
  newLabel = newLabel.replace(
    /\[(\d+)](?:\.|$)/,
    (_, num) => ` #${Number(num) + 1} `
  );
  newLabel = newLabel.replace(/videos_property/, "video ");
  newLabel = newLabel.replace(/building /, "Etapa ");
  newLabel = newLabel.replace(/dateDelivery/, "fecha de entrega");
  newLabel = newLabel.replace(/units/, "unidad");
  newLabel = newLabel.replace(/name/, " nombre");
  newLabel = newLabel.replace(/price/, " precio");
  newLabel = newLabel.replace(/currency/, " moneda");
  newLabel = newLabel.replace(/bedrooms/, " habitación");
  newLabel = newLabel.replace(/bathrooms/, " baño");
  newLabel = newLabel.replace(/halfBathrooms/, " medio baño");
  newLabel = newLabel.replace(/parkingSpots/, " parqueo");
  newLabel = newLabel.replace(/levelFloor/, " nivel");
  newLabel = newLabel.replace(/totalFloor/, " total de pisos");
  newLabel = newLabel.replace(/metersConstruction/, " metros de construcción");
  newLabel = newLabel.replace(/metersLand/, " metros de solar");
  newLabel = newLabel.replace(/isNew/, " es nuevo");
  newLabel = newLabel.replace(/isDelete/, " está eliminado");
  newLabel = newLabel.replace(/maintenanceFee/, " cuota de mantenimiento");
  newLabel = newLabel.replace(/maintenanceCurrency/, " moneda de mantenimiento");
  newLabel = newLabel.replace(/features/, " características");
  newLabel = newLabel.replace(/totalCommission/, " comisión total");
  newLabel = newLabel.replace(/commissionGuaranteed/, " comisión garantizada");
  newLabel = newLabel.replace(
    /characteristics_type_roof_property/,
    " tipo de techo"
  );
  newLabel = newLabel.replace(
    /characteristics_roof_form_property/,
    " forma de techo"
  );
  newLabel = newLabel.replace(/characteristics_frames_property/, " marcos");
  newLabel = newLabel.replace(/characteristics_door_property/, " puertas");
  newLabel = newLabel.replace(/characteristics_closets_property/, " closets");
  newLabel = newLabel.replace(/characteristics_windows_property/, " ventanas");
  newLabel = newLabel.replace(/characteristics_cabinets_property/, " gabinetes");
  newLabel = newLabel.replace(/characteristics_floors_property/, " pisos");
  newLabel = newLabel.replace(
    /characteristics_type_house_property/,
    " tipo de casa"
  );
  newLabel = newLabel.replace(/characteristics_type_property/, " tipo de propiedad");
  newLabel = newLabel.replace(/catchment/, "Captación");
  newLabel = newLabel.replace(/deadline/, "fecha de entrega");
  newLabel = newLabel.replace(/cantUnits/, "unidades en captación");
  newLabel = newLabel.replace(/unidadQuantity/, " cantidad de unidades");

  return newLabel;
};

export default translatePropertyLabels;
